module.exports = __webpack_public_path__ + "h5/img/child-banner-top.1873fcf4.png";